"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appInsights_1 = __importDefault(require("./appInsights"));
const ecommerce_1 = __importDefault(require("./ecommerce"));
const forms_1 = __importDefault(require("./forms"));
const promotion_1 = __importDefault(require("./promotion"));
const monitor_1 = __importDefault(require("./monitor"));
const page_1 = __importDefault(require("./page"));
const consent_1 = __importDefault(require("./consent"));
const newsletter_1 = __importDefault(require("./newsletter"));
/**
 * Prod GTM-ids for specific domains
 */
const Domain = {
    'ida.dk': 'GTM-KQHXHQG',
    'idaforsikring.dk': 'GTM-N2NTXH',
};
class TrackingManager {
    /**
     *
     * @param useGtmProdContainer use prod gtmid @default=false
     * @param domain define environment for gtmid @default=ida
     */
    constructor(useGtmProdContainer = false, domain = 'ida.dk', locale = 'da', applicationInsightsConfig) {
        this.gtmTestId = 'GTM-T2563QJ';
        this.aiManager = null;
        this.monitor = null;
        if (applicationInsightsConfig) {
            this.aiManager = new appInsights_1.default(applicationInsightsConfig.cloudRoleName, applicationInsightsConfig.connectionString, applicationInsightsConfig.enableAutoRouteTracking, applicationInsightsConfig.enableUnhandledPromiseRejectionTracking, applicationInsightsConfig.extensions);
        }
        const gtmContainer = useGtmProdContainer ? Domain[domain] : this.gtmTestId;
        this.locale = locale;
        this.monitor = new monitor_1.default(this.aiManager);
        this.page = new page_1.default(this.monitor);
        this.promotion = new promotion_1.default();
        this.forms = new forms_1.default();
        this.ecommerce = new ecommerce_1.default();
        this.consent = new consent_1.default();
        this.newsletter = new newsletter_1.default();
        this.initialize(gtmContainer);
    }
    initialize(container) {
        var _a, _b, _c;
        if (typeof window !== 'undefined' && document) {
            window.dataLayer = window.dataLayer || [];
            const cookieConsentScript = document.createElement('script');
            cookieConsentScript.id = 'cookieconsent';
            cookieConsentScript.src = 'https://policy.app.cookieinformation.com/uc.js';
            cookieConsentScript.setAttribute('data-culture', this.locale);
            cookieConsentScript.defer = true;
            (_a = document.getElementsByTagName('head')[0]) === null || _a === void 0 ? void 0 : _a.appendChild(cookieConsentScript);
            const gtmHead = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${container}');
      `;
            const gtmBody = `<iframe src="https://www.googletagmanager.com/ns.html?id=${container}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            const gtmHeadScript = document.createElement('script');
            gtmHeadScript.innerHTML = gtmHead;
            const gtmBodyScript = document.createElement('noscript');
            gtmBodyScript.innerHTML = gtmBody;
            (_b = document.getElementsByTagName('head')[0]) === null || _b === void 0 ? void 0 : _b.appendChild(gtmHeadScript);
            (_c = document.getElementsByTagName('body')[0]) === null || _c === void 0 ? void 0 : _c.prepend(gtmBodyScript);
        }
    }
}
exports.default = TrackingManager;
